<template lang="pug">
  #form
    v-layout(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-xs-center ¿Estás seguro de que quieres borrar este folio?
            //v-card-text xxxxxx
            v-spacer.mt-4
            v-layout.px-5
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.bold(color="gray darken-3" flat @click.native="dialog = false") CANCELAR
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.bold(color="gray darken-3" flat @click.native="deleteReport") ELIMINAR FOLIO
    Header
    v-container(fluid)
      v-layout.all(row wrap)
        v-flex(xs12 sm2)
          v-layout(column)
            Side
        v-flex(xs10)
          v-layout(row wrap)
            v-flex#top(xs6)
              h1.form-title.dark-text Postal
            v-flex(xs6)
              v-layout.ml-5.pl-4.justify-center(row wrap)
                v-flex(xs4)
                  p.text-xs-center.mt-3.pt-1 Folio Privado
                v-flex(xs1)
                  v-switch.pt-2.mt-2( color ="red darken-4" v-model="public")
                v-flex(xs4)
                  p.text-xs-center.mt-3.pt-1 Folio Público
            v-flex.postal(xs12 sm12 md7)
              v-layout(column)
                Postal
            v-flex(xs12 sm12 md12 lg5)
              v-layout(column)
                PostalForm
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Specifics
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              News
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Location
          v-divider.form.my-4
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Updates
          v-divider.form.my-4(v-if="isEditing")
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Edit
          v-layout(row wrap)
            v-flex(v-if="isEditing" xs6 justify-start)
              v-btn.dark-btn.bold(v-on:click="openDialog") Eliminar este folio
            v-flex(xs6 justify-end)
              v-btn.dark-btn.bold(
                to="/"
              ) Cancelar
              v-btn.dark-btn.bold(v-if="!isEditing", v-on:click="createReport") Guardar
              v-btn.dark-btn.bold(v-if="isEditing", v-on:click="updateReport") Guardar

</template>

<script>
import * as d3 from "d3";
import * as html2canvas from "html2canvas";
import Header from "@/components/Header.vue";
import Side from "@/components/Side.vue";
import PostalForm from "@/components/PostalForm.vue";
import Postal from "@/components/Postal/Postal.vue";
import Specifics from "@/components/Specifics.vue";
import News from "@/components/News.vue";
import Location from "@/components/Location.vue";
import Updates from "@/components/Updates.vue";
import Edit from "@/components/Edit.vue";

export default {
  name: "Form",
  props: {},
  components: {
    Header,
    Side,
    PostalForm,
    Postal,
    Specifics,
    News,
    Location,
    Updates,
    Edit
  },
  data() {
    return {
      dialog: false,
      user: this.$store.state.user
    };
  },
  watch: {
    public: function(val) {
      this.$notify({
        group: "foo",
        type: "warning",
        title: val == true ? "FOLIO PÚBLICO" : "FOLIO PRIVADO",
        text: "Guardar para actualizar"
      });
    }
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    isEditing() {
      let edit = this.$store.state.editing;
      return edit;
    },
    public: {
      get() {
        return this.$store.state.record.public;
      },
      set(value) {
        this.$store.commit("updatePublic", value);
      }
    }
  },
  methods: {
    requiredData() {
      if (
        this.record.aggressionDate === "" ||
        typeof this.record.aggressionDate === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección fecha del hecho incompleta"
        });
      } else if (
        this.record.state === "" ||
        typeof this.record.state === "undefined" ||
        typeof this.record.state !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección entidad incompleta"
        });
      } else if (
        this.record.municipality === "" ||
        typeof this.record.municipality === "undefined" ||
        typeof this.record.municipality !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección municipio incompleta"
        });
      } else if (
        this.record.legalName === "" ||
        typeof this.record.legalName === "undefined" ||
        typeof this.record.legalName !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección nombre legal incompleta"
        });
      } else if (
        this.record.chosenName === "" ||
        typeof this.record.chosenName === "undefined" ||
        typeof this.record.chosenName !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección nombre elegido o asumido incompleta"
        });
      } else if (
        this.record.whereWasFound === "" ||
        typeof this.record.whereWasFound === "undefined" ||
        typeof this.record.whereWasFound !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección nombre legal incompleta"
        });
      } else if (
        this.record.sexualIdentity === "" ||
        typeof this.record.sexualIdentity === "undefined" ||
        typeof this.record.sexualIdentity !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección identidad sexual incompleta"
        });
      } else if (
        this.record.characteristic === "" ||
        typeof this.record.characteristic === "undefined" ||
        typeof this.record.characteristic !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección característica diferencial incompleta"
        });
      } else if (
        this.record.age == 0 ||
        typeof this.record.age === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección edad incompleta"
        });
      } else if (
        this.record.nationality === "" ||
        typeof this.record.nationality === "undefined" ||
        typeof this.record.nationality !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección nacionalidad incompleta"
        });
      } else if (
        this.record.occupation === "" ||
        typeof this.record.occupation === "undefined" ||
        typeof this.record.occupation !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección ocupación incompleta"
        });
      } else if (
        this.record.details === "" ||
        typeof this.record.details === "undefined" ||
        typeof this.record.details !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección descripción de los hechos incompleta"
        });
      } else if (
        this.record.weapon === "" ||
        typeof this.record.weapon === "undefined" ||
        typeof this.record.weapon !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección arma incompleta"
        });
      } else if (
        this.record.bodyState === "" ||
        typeof this.record.bodyState === "undefined" ||
        typeof this.record.bodyState !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección estado del cuerpo incompleta"
        });
      } else if (
        (this.record.address === "" ||
          typeof this.record.address === "undefined") ||
        (this.record.lat === "" || typeof this.record.lat === "undefined") ||
        (this.record.lng === "" || typeof this.record.lng === "undefined")
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección ubicación en el mapa incompleta"
        });
      } else if (
        this.record.ageGroup === "" ||
        typeof this.record.ageGroup === "undefined" ||
        typeof this.record.ageGroup !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección grupo de edad incompleta"
        });
      } else if (
        this.record.sexualViolence === "" ||
        typeof this.record.sexualViolence === "undefined" ||
        typeof this.record.sexualViolence !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección indicios de violencia sexual incompleta"
        });
      } else if (
        this.record.tortureViolence === "" ||
        typeof this.record.tortureViolence === "undefined" ||
        typeof this.record.tortureViolence !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección indicios de ensañamiento incompleta"
        });
      }else if (
        this.record.wasOffenderFound === "" ||
        typeof this.record.wasOffenderFound === "undefined" ||
        typeof this.record.wasOffenderFound !== 'string'
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección 'hubo detenido' incompleta"
        });
      }  else {
        return true;
      }
    },
    createReport() {
      //console.log(this.record);
      if (this.requiredData()) {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("createReport")
          .then(response => {
            // UploadImage request
            this.uploadImage(response.data.folio)
              .then(result => {
                //console.log(result)
                this.$store.commit("SET_CREATEREPORT_SUCCESS", {
                  pending: false,
                  statusCode: response.status,
                  data: response.data
                });
                this.$notify({
                  group: "foo",
                  type: "success",
                  title: "ÉXITO",
                  text: response.data.message
                });
                //console.log(response, "response")
                this.record.review_reason = "right";
                this.record.review_comments = "";
                this.record.id = response.data["_id"];
                this.record.folio = response.data.folio;
                // console.log(this.record)
                //console.log(response)
                this.$store
                  .dispatch("addReview")
                  .then(response => {
                    // console.log(response)
                    this.$store.commit("resetReview");
                  })
                  .catch(error => {
                    // console.log(error)
                    // console.log(error.response);
                  });
                this.$store.commit("resetRecord");
                this.$router.replace("/");
                this.$store.commit("setIsLoadingState", false);
              })
              .catch(err => {
                console.log(err);
              });

            // UpdateCsv request
            this.updateCsv();
          })
          .catch(error => {
            console.log(error);
            // console.log(error.response);
            this.$store.commit("SET_CREATEREPORT_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
            this.$store.commit("setIsLoadingState", false);
          });
      }
    },
    updateReport() {
      if (this.record.id === "" || typeof this.record.id === "undefined") {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/");
      } else if (this.requiredData()) {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("updateReport")
          .then(response => {
            //console.log(response,'update response');
            // UploadImage request
            this.uploadImage(response.data.folio)
              .then(result => {
                this.$store.commit("SET_UPDATEREPORT_SUCCESS", {
                  pending: false,
                  statusCode: response.status,
                  data: response.data
                });
                this.$notify({
                  group: "foo",
                  type: "success",
                  title: "ÉXITO",
                  text: response.data.message
                });

                this.$store.state.record.review_reason = "right";
                this.$store.state.record.review_comments = "";
                this.$store
                  .dispatch("addReview")
                  .then(response => {
                    // console.log(response)
                    this.$store.commit("resetReview");
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$store.commit("resetRecord");
                this.$router.replace("/");
                this.$store.commit("setIsLoadingState", false);
              })
              .catch(err => {
                console.log(err);
              });
            // UpdateCsv request
            this.updateCsv();
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("SET_UPDATEREPORT_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
            this.$store.commit("setIsLoadingState", false);
          });
      }
    },
    deleteReport() {
      this.dialog = false;
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteReport")
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.$store.commit("SET_DELETEREPORT_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              type: "success",
              title: "ÉXITO",
              text: response.data.message
            });
            this.$store.commit("resetRecord");
            this.$router.replace("/");
            this.$store.commit("setIsLoadingState", false);

            // UpdateCsv request
            this.updateCsv();
          }
        })
        .catch(error => {
          // console.log(error)
          // console.log(error.response);
          this.$store.commit("SET_DELETEREPORT_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
          this.$store.commit("setIsLoadingState", false);
        });
    },
    uploadImage(folio) {
      // console.log("upload image");
      return new Promise((resolve, reject) => {
        html2canvas(d3.select("#postal").node()).then(canvas => {
          let imageData = {
            folio: folio,
            file: canvas.toDataURL("image/jpeg")
          };
        // document.body.appendChild(canvas)
        //  window.open(imageData.file);

          this.$store
            .dispatch("uploadImage", imageData)
            .then(response => {
              this.$store.commit("SET_UPLOADIMAGE_SUCCESS", {
                pending: false,
                statusCode: response.status
              });
              return resolve(response.data);
            })
            .catch(error => {
              this.$store.commit("SET_UPLOADIMAGE_FAILURE", {
                pending: false,
                statusCode: error.status
              });
              return reject("error");
            });
        });
      });
    },
    updateCsv() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("updateCsv")
          .then(response => {
            this.$store.commit("SET_UPDATECSV_SUCCESS", {
              pending: false,
              statusCode: response.status
            });
            return resolve("ok");
          })
          .catch(error => {
            this.$store.commit("SET_UPDATECSV_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            return reject("error");
          });
      });
    },
    openDialog() {
      this.dialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.all {
  max-width: 1900px;
}
p.headline {
  color: #be3117;
  font-size: 30px !important;
  font-weight: 600;
}
.postal {
  min-width: 570px;
}

</style>
